<template>
    <div v-if="invitations.data && invitations.data.length">
        <div class="columns">
            <div class="column is-9">
                <h2 class="title is-1">My <span class="color-is-primary">pending invitations</span></h2>
            </div>
            <div class="column is-3 align-vertical has-text-right">
                <a :href="create_route" class="button is-medium is-outlined is-flts-blue">Invite employee</a>
            </div>
        </div>

        <div class="columns">
            <div class="column is-12">
                <div class="field has-addons">
                    <p class="control is-expanded">
                        <input v-model="search_query" class="input is-medium" type="text" placeholder="Search for invitation">
                    </p>
                    <p class="control">
                        <button class="button is-medium" @click="filter">
                            Search
                        </button>
                    </p>
                </div>
            </div>
        </div>

        <table class="table is-striped is-fullwidth">
            <tr>
                <th>#</th>
                <th>Email</th>
                <th>Division</th>
                <th>Department</th>
                <th>Position</th>
                <th class="table-actions"></th>
            </tr>
            <tr v-for="(invitation, index) in invitations.data" :key="index">
                <td>{{ (invitations.meta.pagination.per_page * (invitations.meta.pagination.current_page - 1)) + index + 1 }}.</td>
                <td>{{ invitation.email }}</td>
                <td>{{ invitation.division }}</td>
                <td>{{ invitation.department }}</td>
                <td>{{ invitation.position }}</td>
                <td class="is-right">
                    <button class="button is-small is-flts-blue" title="Resend Invitation" @click="resendInvitation(invitation.id)"><i class="fa fa-refresh"></i></button>
                    <a :href="edit_route.replace(':id', invitation.id)" class="button is-small is-flts-blue"><i class="fa fa-pencil" title="Edit Invitation"></i></a>
                    <button class="button is-small is-danger" title="Remove Invitation" @click="deleteInvitation(invitation.id)">
                        <i class="fa fa-remove"></i>
                    </button>
                </td>
            </tr>
        </table>
        <Pagination v-if="invitations.meta.pagination" 
            :pagination="invitations.meta.pagination" 
            @page-change="fetchData"
        />
    </div>
</template>

<script>
import Pagination from '../../../components/Html/common/Pagination.vue';
export default {
  components: {
    Pagination
  },
  props: {
    get_invitations_list_route: { type: String, required: true },
    create_route: { type: String, required: true },
    edit_route: { type: String, required: true },
    destroy_route: { type: String, required: true },
    resend_route: { type: String, required: true }
  },
  data() {
    return {
      invitations: [],
      search_query: ''
    };
  },
  computed: {
    totalPages() {
      return this.invitations.last_page;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData(page = 1) {
      const params = {
        search_query: this.search_query,
        page: page
      };

      axios.get(this.get_invitations_list_route, { params })
        .then((response) => {
          if (response.data.success) {
            this.invitations = response.data.data;
          }
        });
    },
    changePageFromLink(link) {
      if (link.url) {
        const url_params = new URLSearchParams(link.url.split('?')[1]);
        const page = url_params.get('page');
        this.fetchData(Number(page));
      }
    },
    filter() {
      this.fetchData();
    },
    resendInvitation(id) {
      axios.post(this.resend_route.replace(':id', id))
        .then(response => {
          if (response.data.success) {
            Swal.fire({
              title: 'Success',
              text: 'Invitation resent successfully!',
              type: 'success'
            });
          }
        })
        .catch(error => {          
          if (error.response) {
            if (error.response.status === 429) {
              Swal.fire({
                title: 'Too Many Requests',
                text: error.response.data.message,
                type: 'warning'
              });
            }
          }
        });
    },
    deleteInvitation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wound not be able to revert this!',
        type: 'warning',
        reverseButtons: true,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: '#03a9f4',
        confirmButtonClass: 'button is-primary',
        cancelButtonClass: 'button is-danger is-medium',
        cancelButtonColor: '#f44336'
      })
        .then(result => {
          if (result.value) {
            axios.delete(this.destroy_route.replace(':id', id))
              .then(response => {
                if (response.data.success) {
                  Swal.fire('Deleted!', 'The invitation has been removed.', 'success');
                  this.fetchData();
                } else {
                  Swal.fire('Error', response.data.message, 'error');
                }
              })
              .catch(error => {
                let errorMessage = 'Failed to delete the invitation.';
                if (error.response && error.response.data.message) {
                  errorMessage = error.response.data.message;
                }
                Swal.fire('Error', errorMessage, 'error');
              });
          }
        });
    }
  }
};
</script>